import ClassNames from "classnames";
import * as React from "react";

import i18next from "../../../i18n";
import {Col, Container, Row, Section} from "../../../reusable";

import * as Style from "./BigFeatures.scss";
import anonymous from "assets/images/anonymous.svg";
import fair from "assets/images/fair.svg";
import fast from "assets/images/fast.svg";

const entries = [
    {
        img: fair,
        heading: i18next.t("bigFeatures.fair.shortDescription"),
        text: i18next.t("bigFeatures.fair.longDescription"),
    },
    {
        img: fast,
        heading: i18next.t("bigFeatures.fast.shortDescription"),
        text: i18next.t("bigFeatures.fast.longDescription"),
    },
    {
        img: anonymous,
        heading: i18next.t("bigFeatures.anonymous.shortDescription"),
        text: i18next.t("bigFeatures.anonymous.longDescription"),
    },
];

interface EntryProps {
    idx: number;
    entry: (typeof entries)[0];
}

const Entry = ({idx, entry}: EntryProps) => {
    const classNameImgCol = ClassNames("text-center mb-4 mb-sm-0", {"order-sm-last": idx % 2 === 0});

    return (
        <Row className={Style.entry}>
            <Col md={6} className={classNameImgCol}>
                <img src={entry.img} width={150} />
            </Col>
            <Col md={6}>
                <h3 className="text-center">{entry.heading}</h3>
                <p>{entry.text}</p>
            </Col>
        </Row>
    );
};

const BigFeatures = () => (
    <Section className={Style.features}>
        <Container>
            <h2 className="text-center">Fast, Secure and Fair</h2>
            {entries.map((entry, idx) => (
                <Entry key={idx} entry={entry} idx={idx} />
            ))}
        </Container>
    </Section>
);

export default BigFeatures;
